import React from "react";
import NoData from "../../../../../components/noData/noData";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import { Icons } from "../../../../../../utils/icons";
import { useNavigate } from "react-router-dom";

// Reusable DetailCard component
const DetailCard = ({ label, value }) => (
  <div className="grid grid-cols-2">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-blue-900">{value || "-"}</span>
  </div>
);

// Skeleton Loader
const DetailSkeleton = () => (
  <div className="grid grid-cols-2 animate-pulse">
    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" />
    <div className="h-5 bg-gray-200 rounded w-2/3 mb-2" />
  </div>
);

const BasicCard = ({ staff, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex flex-col gap-2 rounded-md h-full">
        {Array.from({ length: 3 }).map((_, idx) => (
          <DetailSkeleton key={idx} />
        ))}
      </div>
    );
  }

  if (!staff) {
    return (
      <p className="text-gray-500 p-4 bg-white rounded-md">
        <NoData
          title="No Result Found"
          message="Please try again with another keywords or maybe use generic term"
          buttonText={null}
        />
      </p>
    );
  }
  const basicDetails = [
    { label: "Phone Number", value: staff.phone },
    { label: "Date Of Birth", value: staff.dob },
    { label: "Alternate Phone Number", value: staff.phone2 },
    { label: "Father Name", value: staff.father_name },
    { label: "Email Address", value: staff.email },
    { label: "Mother Name", value: staff.mother_name },
    { label: "Date Of Joining", value: staff.joining_at },
    { label: "Gender", value: staff.gender },
    { label: "Department", value: staff.department?.name },
    { label: "Marital Status", value: staff.marital_status },
    { label: "Designation", value: staff.designation?.name },
    { label: "Date Of Marriage", value: staff.date_of_marriage },
    { label: "Employee Type", value: staff.emp_type },
    { label: "Partner Name", value: staff.spouse_name },
  ];

  return (
    <div className="flex flex-col gap-2 rounded-md h-full">
      {/* Basic Details */}
      <div>
        <div className="border-b flex justify-between p-4 text-lg font-semibold text-blue-900 bg-white px-4 py-2">
          <h2 className="text-lg font-semibold text-blue-900">Basic Details</h2>
          <DefaultButton
            name={Icons.EDIT}
            onClick={() => navigate(`/hr/staff-directory/edit/${staff.uuid}`)}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-2 p-4 bg-white">
          {basicDetails.map((item, idx) => (
            <DetailCard key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      </div>

      {/* Addresses */}
      <div className="grid grid-cols-2 gap-x-2 gap-y-2">
        {/* Current Address */}
        <div className="bg-white">
          <div className="border-b">
            <h2 className="text-lg font-semibold text-blue-900 bg-white px-4 py-2">
              Current Address
            </h2>
          </div>
          <div className="grid gap-y-2 p-4 bg-white">
            <DetailCard label="Country" value={staff.country} />
            <DetailCard label="State" value={staff.state} />
            <DetailCard label="City" value={staff.city} />
            <DetailCard label="Pincode" value={staff.pincode} />
            <DetailCard label="Address" value={staff.address} />
          </div>
        </div>

        {/* Permanent Address */}
        <div className="bg-white">
          <div className="border-b">
            <h2 className="text-lg font-semibold text-blue-900 bg-white px-4 py-2">
              Permanent Address
            </h2>
          </div>
          <div className="grid gap-y-2 p-4 bg-white">
            <DetailCard label="Country" value={staff.country2} />
            <DetailCard label="State" value={staff.state2} />
            <DetailCard label="City" value={staff.city2} />
            <DetailCard label="Pincode" value={staff.pincode2} />
            <DetailCard label="Address" value={staff.address2} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicCard;
